import React from "react";

const FreeApp = () => {
  return (
    <div className="free-app-container">
      <div className="download-free-app">
        <div className="download-app-container">
          <span>Download our</span>
          <span>free app!</span>
        </div>
        <span>
          24/7 in-app support, plus safety features and emergency calls.
        </span>
        <button className="download-app-button">Download App</button>
      </div>
      <div className="border-seperator"></div>
      <div className="code-container">
        <div>
          <span>Scan the QR code with your smartphone camera</span>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="240"
            height="240"
            viewBox="0 0 240 240"
            fill="none"
          >
            <g>
              <path d="M90 0H0V90H90V0ZM75 75H15V15H75V75Z" fill="white" />
              <path
                d="M30 30H60V60H30V30ZM0 240H90V150H0V240ZM15 165H75V225H15V165Z"
                fill="white"
              />
              <path
                d="M30 180H60V210H30V180ZM150 0V90H240V0H150ZM225 75H165V15H225V75Z"
                fill="white"
              />
              <path
                d="M180 30H210V60H180V30ZM30 105H0V135H45V120H30V105ZM105 135H135V165H105V135ZM45 105H75V120H45V105ZM135 180H105V195H120V210H135V195V180ZM90 105V120H75V135H105V105H90ZM120 60H135V90H120V60ZM135 120V135H165V105H120V120H135ZM105 90H120V105H105V90ZM135 210H165V240H135V210ZM105 210H120V240H105V210ZM135 165H150V180H135V165ZM135 45V15H120V0H105V60H120V45H135ZM180 210H195V240H180V210ZM180 180H210V195H180V180ZM165 195H180V210H165V195ZM150 180H165V195H150V180ZM210 150V165H225V180H240V150H225H210ZM225 195H210V240H240V210H225V195ZM150 150V165H195V135H165V150H150ZM180 105V120H210V135H240V105H210H180Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_1211_2014">
                <rect width="240" height="240" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default FreeApp;
